/**
 *
 * CapSupportVideosWrapper
 *
 */
import React, { useState } from "react";
import ResizablePIP from "./ResizablePIP";
import { getElementByXpath } from "./utils";
import "./_capSupportVideosWrapper.scss";

const CapSupportVideosWrapper = (props) => {
  const { children, targetElements = {}, locale = "en" } = props || {};
  const [showPIP, setShowPIP] = useState(false);
  const [PIPContentLink, setPIPContentLink] = useState("");
  const [PIPFooterContent, setPIPFooterContent] = useState({});
  const [showMaximised, setShowMaximised] = useState(false);
  const cssSelectors = [];
  if (Object.keys(targetElements)?.length) {
    Object.keys(targetElements).forEach((targetElement) => {
      cssSelectors.push({
        cssSelector: targetElement,
        locale,
        ...targetElements[targetElement],
      });
    });
  }
  setTimeout(() => {
    cssSelectors.forEach((selector) => {
      const {
        support_link: { target_url: linkTargetUrl = {} } = {},
        support_video: { target_url: videoTargetUrl = {} } = {},
        locale,
        cssSelector,
      } = selector || {};
      let matchedNodesXpath = !!cssSelector && getElementByXpath(cssSelector);
      const handleOnClickVideoLink = () => {
        setPIPContentLink(videoTargetUrl?.[locale]?.href);
        setPIPFooterContent({
          videoTitle: videoTargetUrl?.[locale]?.videoTitle,
          supportDoc: videoTargetUrl?.[locale]?.supportDoc,
        });
        setShowPIP(true);
      };
      const handleOpenSupportLink = () =>
        window.open(linkTargetUrl?.[locale]?.href, "_blank");

      if (selector?.support_video?.target_url?.default?.href) {
        if (
          !!matchedNodesXpath &&
          !document.getElementById(`demo-video-${cssSelector}`)
        ) {
          let videoAnchor = document.createElement("a");
          videoAnchor.textContent = videoTargetUrl?.[locale].label;
          videoAnchor.id = `demo-video-${cssSelector}`;
          videoAnchor.style.marginLeft = "2px";
          videoAnchor.style.marginTop = "2px";
          videoAnchor.style.fontSize = "14px";
          videoAnchor.onclick = handleOnClickVideoLink;

          const videoIconElement = document.createElement("i");
          videoIconElement.innerHTML = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M14.756 11.032a1.194 1.194 0 0 1 0 1.921l-2.937 2.17a1.194 1.194 0 0 1-1.904-.96v-4.34a1.194 1.194 0 0 1 1.904-.96l2.937 2.17zM12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18z"
              id="play_svg__a"
            ></path>
          </svg>`;
          videoIconElement.onclick = handleOnClickVideoLink;
          videoIconElement.style.marginLeft = "2px";
          videoIconElement.style.cursor = "pointer";
          videoIconElement.style.color = "#2466eb";
          videoIconElement.style.fontSize = "18px";

          matchedNodesXpath.appendChild(videoIconElement);
          matchedNodesXpath.appendChild(videoAnchor);
        }
      } else if (selector?.support_link?.target_url?.default?.href) {
        if (
          !!matchedNodesXpath &&
          !document.getElementById(`support-link-${cssSelector}`)
        ) {
          let linkAnchor = document.createElement("a");
          linkAnchor.href = linkTargetUrl?.[locale]?.href;
          linkAnchor.textContent = linkTargetUrl?.[locale].label;
          linkAnchor.target = "_blank";
          linkAnchor.id = `support-link-${cssSelector}`;
          linkAnchor.style.marginLeft = "2px";
          linkAnchor.style.marginTop = "2px";
          linkAnchor.style.fontSize = "14px";
          linkAnchor.onclick = handleOpenSupportLink;

          const helpIconElement = document.createElement("i");
          helpIconElement.innerHTML = `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
            <path
              id="help_svg__a"
              d="M9 16h2v-2H9v2zm1-16C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14C7.79 4 6 5.79 6 8h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
            ></path>
          </svg>`;
          helpIconElement.onclick = handleOpenSupportLink;
          helpIconElement.style.marginLeft = "2px";
          helpIconElement.style.cursor = "pointer";
          helpIconElement.style.fontSize = "16px";
          helpIconElement.style.color = "#2466eb";

          matchedNodesXpath.appendChild(helpIconElement);
          matchedNodesXpath.appendChild(linkAnchor);
        }
      }
    });
  }, 3000)

  const handleOpenInNew = () => {
    window.open(PIPContentLink, "_blank");
  };
  const handleShowMaximised = (value) => {
    setShowMaximised(value);
  };
  const handleClosePIPContainer = () => {
    setShowMaximised(false);
    setShowPIP(false);
  };
  return (
    <div>
      {showPIP && (
        <ResizablePIP
          closePIPContainer={handleClosePIPContainer}
          handleOpenInNew={handleOpenInNew}
          handleShowMaximised={handleShowMaximised}
          showMaximised={showMaximised}
          footerContent={PIPFooterContent}
        >
          <iframe
            width="100%"
            height="100%"
            src={`${PIPContentLink}?controls=1`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            style={{ borderRadius: 4 }}
          />
        </ResizablePIP>
      )}
      {children}
    </div>
  );
};

export default CapSupportVideosWrapper;
